import { RootState } from 'handlers';

export const getYourAddressData = ({ yourAddress }: RootState) => yourAddress;
